var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2572 161.28H375.17L399.669 199.291V225.28H71.7557L47.2572 187.269V161.28ZM50.8532 167.68V184.358L73.1032 218.88H396.073V202.202L373.823 167.68H50.8532Z",
    fill: "#323F49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8532 184.358V167.68H373.823L396.073 202.202V218.88H73.1032L50.8532 184.358Z",
    fill: "#323F49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1544 225.28H407.067L431.566 263.291V289.28H103.653L79.1544 251.269V225.28ZM82.7505 231.68V248.358L105 282.88H427.97V266.202L405.72 231.68H82.7505Z",
    fill: "#D85A62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7505 248.358V231.68H405.72L427.97 266.202V282.88H105L82.7505 248.358Z",
    fill: "#D85A62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.051 289.28H438.964L463.463 327.291V353.28H135.55L111.051 315.269V289.28ZM114.647 295.68V312.358L136.897 346.88H459.867V330.202L437.617 295.68H114.647Z",
    fill: "#6AB97B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.647 312.358V295.68H437.617L459.867 330.202V346.88H136.897L114.647 312.358Z",
    fill: "#6AB97B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.949 353.28H470.861L495.36 391.291V417.28H167.447L142.949 379.269V353.28ZM146.545 359.68V376.358L168.795 410.88H491.764V394.202L469.514 359.68H146.545Z",
    fill: "#2D8CC5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.545 376.358V359.68H469.514L491.764 394.202V410.88H168.795L146.545 376.358Z",
    fill: "#2D8CC5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.36 97.28H343.273L367.771 135.291V161.28H39.8585L15.36 123.269V97.28ZM18.956 103.68V120.358L41.2059 154.88H364.175V138.202L341.925 103.68H18.956Z",
    fill: "#FFBE98"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.956 120.358V103.68H341.925L364.175 138.202V154.88H41.2059L18.956 120.358Z",
    fill: "#FFBE98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ffb438998e2de06f1b43aa86106fe1ac.svg";
export { ForwardRef as ReactComponent };